"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePeriodEnum = void 0;
var InvoicePeriodEnum;
(function (InvoicePeriodEnum) {
    InvoicePeriodEnum["Monthly"] = "Monthly";
    InvoicePeriodEnum["Every2ndMonth"] = "Every2ndMonth";
    InvoicePeriodEnum["Quarterly"] = "Quarterly";
    InvoicePeriodEnum["HalfYearly"] = "HalfYearly";
    InvoicePeriodEnum["Annually"] = "Annually";
})(InvoicePeriodEnum = exports.InvoicePeriodEnum || (exports.InvoicePeriodEnum = {}));
